// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const minior_violet: PokeData = {
  "id": 10142,
  "name": "minior-violet",
  "height": 3,
  "weight": 3,
  "base_experience": 175,
  "types": [
    PokeType.ROCK,
    PokeType.FLYING
  ],
  "api_moves": [
    "tackle",
    "take-down",
    "double-edge",
    "confuse-ray",
    "defense-curl",
    "self-destruct",
    "swift",
    "explosion",
    "rollout",
    "ancient-power",
    "cosmic-power",
    "rock-polish",
    "power-gem",
    "stealth-rock",
    "autotomize",
    "shell-smash"
  ],
  "moves": [
    "tackle",
    "confuse-ray",
    "ancient-power",
    "stealth-rock",
    "gust",
    "tailwind",
    "rock-throw",
    "peck",
    "sky-attack",
    "acrobatics",
    "stone-crush",
    "roost",
    "air-slash"
  ],
  "evolution_chain": {
    "id": 400,
    "item": null,
    "species": [
      {
        "name": "minior",
        "order": 774,
        "types": [
          PokeType.ROCK,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 86,
    "speed": 171,
    "ability_power": 143
  },
  "stat_changes": [],
  "catch_rate": 30,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
